import { useState, useCallback } from 'react'

export interface UseCertificateSelectionProps {
  certificates: any[]
}

export const useCertificateSelection = ({ certificates }: UseCertificateSelectionProps) => {
  const [selectedIds, setSelectedIds] = useState<string[]>([])
  const [selectMode, setSelectMode] = useState(false)

  const toggleSelected = useCallback((id: string) => {
    setSelectedIds(prev => 
      prev.includes(id) 
        ? prev.filter(x => x !== id) 
        : [...prev, id]
    )
  }, [])

  const selectAll = useCallback(() => {
    const allIds = certificates.map(cert => cert.id)
    setSelectedIds(allIds)
  }, [certificates])

  const clearSelection = useCallback(() => {
    setSelectedIds([])
  }, [])

  const toggleSelectMode = useCallback(() => {
    setSelectMode(prev => !prev)
    if (selectMode) {
      clearSelection()
    }
  }, [selectMode, clearSelection])

  const isSelected = useCallback((id: string) => {
    return selectedIds.includes(id)
  }, [selectedIds])

  const selectedCertificates = useCallback(() => {
    return certificates.filter(cert => selectedIds.includes(cert.id))
  }, [certificates, selectedIds])

  const isAllSelected = selectedIds.length === certificates.length && certificates.length > 0

  const hasSelection = selectedIds.length > 0

  return {
    selectedIds,
    selectMode,
    isSelected,
    isAllSelected,
    hasSelection,
    selectedCertificates: selectedCertificates(),
    toggleSelected,
    selectAll,
    clearSelection,
    toggleSelectMode,
    setSelectMode,
  }
}
